import { useSearchParams } from '@remix-run/react'

export function useImmunologicalBackgroundParams() {
	const [searchParams, setSearchParams] = useSearchParams()
	const selectedImmunologicalBackground = searchParams.getAll(
		'immunological-background',
	)
	function toggleImmunologicalBackgroundParam(
		immunologicalBackgroundId: string,
	) {
		if (selectedImmunologicalBackground.includes(immunologicalBackgroundId)) {
			setSearchParams(searchParams => {
				searchParams.delete(
					'immunological-background',
					immunologicalBackgroundId,
				)
				return searchParams
			})
		} else {
			setSearchParams(searchParams => {
				searchParams.append(
					'immunological-background',
					immunologicalBackgroundId,
				)
				return searchParams
			})
		}
	}
	return { selectedImmunologicalBackground, toggleImmunologicalBackgroundParam }
}
